import styled from "styled-components"
import { colourFromProps } from "./theme"

// Text is a convenience wrapper to provide consistent sizing and colouring of
// an inline span of text, e.g.
// <Text small secondary>Something unimportant</Text>
export default styled.span`
  font-size: ${(props) =>
    props.smaller ? "0.8" : props.small ? "0.9" : "1"}rem;
  color: ${colourFromProps};
  white-space: ${(props) => (props.noWrap ? "nowrap" : "normal")};
`
